import { clientAxios } from '@/plugins/axios'

const baseURL = '/v1/cart'

export const getCart = (is_subscription) => clientAxios.get(`${baseURL}/items`, { params: { is_subscription } })
export const addCartItem = (body) => clientAxios.post(`${baseURL}/items/new`, body)
export const updateCartItem = (cart_item_id, body) => clientAxios.put(`${baseURL}/items/update/${cart_item_id}`, body)
export const syncCarts = (carts) =>
  clientAxios.post(`${baseURL}/items/sync`, {
    items: carts,
  })
export const deleteCartItem = (cart_item_id) => clientAxios.delete(`${baseURL}/items/delete/${cart_item_id}`)

export const checkCart = (items) => clientAxios.post(`${baseURL}/items/check`, { items })
